import React, { Component } from 'react';
import { Link } from 'gatsby';
import Tags from './tag';

const formatDate = raw => {
  if (!raw) return '';
  const d = new Date(raw);
  if (isNaN(d.getTime())) return raw.split('T')[0];
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
};

// The title is the card's link; its ::after overlay stretches over the whole
// card so a click anywhere still opens the post. The card can't be one big
// <a>: the tag links inside it would be links nested in a link, which HTML
// doesn't allow (the parser splits the outer one into empty links).
const CardTitle = ({ props }) => (
  <h2 className="post-card-title">
    <Link
      to={'/' + props.sourceInstanceName + props.node.fields.slug}
      className="post-card-title-link"
    >
      {props.node.frontmatter.title || props.node.fields.slug}
    </Link>
  </h2>
);

export default props => {
  const hasImage = Boolean(props.node.frontmatter.thumbnail);
  return (
    <article
      className={`post-card ${props.postClass} ${
        hasImage ? `with-image` : `no-image`
      }`}
    >
      {hasImage ? (
        <ContentWithImage props={props} />
      ) : (
        <ContentNoImage props={props} />
      )}
    </article>
  );
};

class ContentNoImage extends Component {
  render() {
    const { props } = this.props;
    return (
      <div className="post-card-link">
        <div className="post-card-content">
          <div className="post-card-body-group">
            <div className="post-card-meta">
              <span className="post-card-date">
                {formatDate(props.node.frontmatter.date)}
              </span>
              <Tags tags={props.node.frontmatter.tags} />
            </div>
            <CardTitle props={props} />
            <p className="post-card-body">
              {props.node.frontmatter.description || props.node.excerpt}
            </p>
          </div>
          <span className="post-card-readmore" aria-hidden="true">
            Read more →
          </span>
        </div>
      </div>
    );
  }
}

class ContentWithImage extends Component {
  render() {
    const { props } = this.props;
    const description = props.node.frontmatter.description || props.node.excerpt;
    const thumb = props.node.frontmatter.thumbnail.childImageSharp.fluid.src;
    return (
      <div className="post-card-link">
        <div
          className="post-card-image"
          style={{ backgroundImage: `url(${thumb})` }}
        />
        <div className="post-card-content">
          <div className="post-card-body-group">
            <div className="post-card-meta">
              <span className="post-card-date">
                {formatDate(props.node.frontmatter.date)}
              </span>
              <Tags tags={props.node.frontmatter.tags} />
            </div>
            <CardTitle props={props} />
            {description && <p className="post-card-body">{description}</p>}
          </div>
          <span className="post-card-readmore" aria-hidden="true">
            Read more →
          </span>
        </div>
      </div>
    );
  }
}
